import { FC, useMemo } from 'react';
import { ICellRendererParams } from 'ag-grid-community';
import { stripQuoteArtifacts } from '../../util/transform';

const CheckmateStringRenderer: FC<ICellRendererParams> = (props: ICellRendererParams) => {


  const value = useMemo(() => {
    // if (Array.isArray(props.value) && props.value?.length) {
    //   const returnValue = props.value.map((value) => {
    //     return value;
    //   })
    //   return returnValue;
    // }
    return props.value;
  }, [props.value]);

  const mapValues = (string: string, index: number) => {
    const stripped = stripQuoteArtifacts(string);
    let displayValue = Array.isArray(stripped) ? stripped.join(', ') : stripped;
    if (displayValue?.toLowerCase() === 'null' || displayValue?.toLowerCase() === 'none') {
      displayValue = '';
    }
    return <div key={index}><span>{displayValue}</span><br/></div>
  }

  return <div className="line-break-cell">
    {Array.isArray(value) && !!value?.length && value.map((string, index) => {
      return mapValues(string, index);
    })}
    {typeof value === 'string' && mapValues(value, 0)}
  </div>
};

export default CheckmateStringRenderer